






















import { Component, Vue } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import Module from '@/components/global/Module.vue';
import ModalContainer from '@/components/modals/ModalContainer.vue';
import TeacherMenu from '@/components/teacher/TeacherMenu.vue';
import { Teacher as ITeacher } from '@/models/Teachers';
import Teacher from '@/services/Teacher';
import Share from '@/components/teacher/Share.vue';
import { ModuleActions } from '@/models/Enums';
import Loader from '@/components/global/Loader.vue';
import { IModule } from '@/models/Modules';
import Modules from '@/services/Modules';

@Component({
  components: {
    Loader,
    Share,
    TeacherMenu,
    draggable,
    Module,
    ModalContainer,
  },
})
export default class TeacherModules extends Vue {
  public teacher: ITeacher | null = null;
  modules: IModule[] = [];
  sortedModules: IModule[] = [];
  initiated = false;

  get moduleActions() {
    return [ModuleActions.Link];
  }

  async created() {
    this.teacher = await Teacher.getLoggedInTeacher();
    await this.getData();
  }

  async getData() {
    if (!this.teacher) {
      this.initiated = true;
      return;
    }

    const observer = Modules.getModulesObserverByTeacherEmail(this.teacher.email);
    if (observer) {
      await observer.onSnapshot(async snapshot => {
        if (!snapshot.empty) {
          const modules: IModule[] = [];
          snapshot.forEach(doc => {
            const module = doc.data() as IModule;
            module.id = doc.id;
            modules.push(module);
          });

          this.modules = modules;
          this.setSortedModules();
        }

        this.initiated = true;
      });
    } else {
      this.initiated = true;
    }
  }

  setSortedModules() {
    if (!this.teacher?.modules) {
      this.sortedModules = this.modules;
      return;
    }

    this.sortedModules = this.teacher?.modules.reduce((all, mId) => {
      const module = this.modules.find(m => m.id === mId);
      if (module) {
        all.push(module);
      }
      return all;
    }, [] as IModule[]);
  }
}
